<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="患者名称" prop="name">
        <el-input
          v-model="queryParams.name"
          placeholder="请输入名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="电话" prop="phone">
        <el-input
          v-model="queryParams.phone"
          placeholder="请输入电话"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
<!--      <el-col :span="1.5">-->
<!--        <el-button-->
<!--          type="primary"-->
<!--          plain-->
<!--          icon="el-icon-plus"-->
<!--          size="mini"-->
<!--          @click="handleAdd"-->
<!--          v-hasPermi="['wxCp:ExternalUser:add']"-->
<!--        >新增</el-button>-->
<!--      </el-col>-->
<!--      <el-col :span="1.5">-->
<!--        <el-button-->
<!--          type="success"-->
<!--          plain-->
<!--          icon="el-icon-edit"-->
<!--          size="mini"-->
<!--          :disabled="single"-->
<!--          @click="handleUpdate"-->
<!--          v-hasPermi="['wxCp:ExternalUser:edit']"-->
<!--        >修改</el-button>-->
<!--      </el-col>-->
<!--      <el-col :span="1.5">-->
<!--        <el-button-->
<!--          type="danger"-->
<!--          plain-->
<!--          icon="el-icon-delete"-->
<!--          size="mini"-->
<!--          :disabled="multiple"-->
<!--          @click="handleDelete"-->
<!--          v-hasPermi="['wxCp:ExternalUser:remove']"-->
<!--        >删除</el-button>-->
<!--      </el-col>-->
<!--      <el-col :span="1.5">-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          icon="el-icon-download"-->
<!--          size="mini"-->
<!--          @click="handleExport"-->
<!--          v-hasPermi="['wxCp:ExternalUser:export']"-->
<!--        >导出</el-button>-->
<!--      </el-col>-->
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="userList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
<!--      <el-table-column label="主键" align="center" prop="id" />-->
      <el-table-column label="客户id" align="center" prop="externalUserid" />
      <el-table-column label="名字" align="center" prop="name" />
      <el-table-column label="头像" align="center" prop="avatar" >
        <template slot-scope="scope">
          <img style="width: 50px;height: 50px" :src="scope.row.avatar">
        </template>
      </el-table-column>
      <el-table-column label="客户类型" align="center" prop="type">
        <template slot-scope="scope">
          {{ getSelectNameByEnumsAndValue(externalUserTypeList, scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column label="性别" align="center" prop="gender">
        <template slot-scope="scope">
          {{ getSelectNameByEnumsAndValue(genderList, scope.row.gender) }}
        </template>
      </el-table-column>
      <el-table-column label="unionid" align="center" prop="unionid" />
      <el-table-column label="电话" align="center" prop="phone" />
      <el-table-column label="注册时间" align="center" prop="registerDate" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.registerDate, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['wxCp:ExternalUser:edit']"
          >修改</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handlePreview(scope.row)"
            v-hasPermi="['wxCp:ExternalUser:edit']"
          >查看信息登记表</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改企业微信-外部客户信息对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="外部用户id" prop="externalUserid">
          <el-input v-model="form.externalUserid" placeholder="请输入外部用户id" />
        </el-form-item>
        <el-form-item label="外部联系人的名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入外部联系人的名称" />
        </el-form-item>
        <el-form-item label="外部联系人头像" prop="avatar">
          <el-input v-model="form.avatar" placeholder="请输入外部联系人头像" />
        </el-form-item>
        <el-form-item label="外部联系人性别 0-未知 1-男性 2-女性" prop="gender">
          <el-input v-model="form.gender" placeholder="请输入外部联系人性别 0-未知 1-男性 2-女性" />
        </el-form-item>
        <el-form-item label="外部联系人在微信开放平台的唯一身份标识" prop="unionid">
          <el-input v-model="form.unionid" placeholder="请输入外部联系人在微信开放平台的唯一身份标识" />
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入电话" />
        </el-form-item>
        <el-form-item label="更新时间" prop="updateDate">
          <el-date-picker clearable
            v-model="form.updateDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择更新时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="创建时间" prop="createDate">
          <el-date-picker clearable
            v-model="form.createDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择创建时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="注册时间" prop="registerDate">
          <el-date-picker clearable
            v-model="form.registerDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择注册时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="问卷填写的id" prop="baseInfoSurveyId">
          <el-input v-model="form.baseInfoSurveyId" placeholder="请输入问卷填写的id" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {addExternalUser, delExternalUser, getExternalUser, listExternalUser, updateExternalUser} from "@/api/wxCp/ExternalUser";

  // 读取公共枚举
  import {getEnumByClassFullName} from "@/api/biz/common";
  export default {
  name: "ExternalUser",
  data() {
    return {
      externalUserTypeList: [
          {"value":1,"name":"微信用户"},
        {"value":2,"name":"企微用户"}],
      genderList: [],
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 企业微信-外部客户信息表格数据
      userList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        externalUserid: null,
        name: null,
        avatar: null,
        type: null,
        gender: null,
        unionid: null,
        phone: null,
        updateDate: null,
        createDate: null,
        registerDate: null,
        baseInfoSurveyId: null
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      }
    };
  },
  created() {
    this.getUserGenderEnum();
    this.getList();
  },
  methods: {
    getUserGenderEnum() {
      getEnumByClassFullName("com.myzs.project.biz.enums.UserGenderEnum").then(res => {
        this.genderList = res.data;
      })
    },
    /** 查询企业微信-外部客户信息列表 */
    getList() {
      this.loading = true;
      listExternalUser(this.queryParams).then(response => {
        this.userList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        externalUserid: null,
        name: null,
        avatar: null,
        type: null,
        gender: null,
        unionid: null,
        phone: null,
        updateDate: null,
        createDate: null,
        registerDate: null,
        baseInfoSurveyId: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加企业微信-外部客户信息";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids
      getExternalUser(id).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改企业微信-外部客户信息";
      });
    },
    /** 查看信息登记表 */
    handlePreview(row) {
      
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateExternalUser(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addExternalUser(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal.confirm('是否确认删除企业微信-外部客户信息编号为"' + ids + '"的数据项？').then(function() {
        return delExternalUser(ids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('wxCp/user/export', {
        ...this.queryParams
      }, `user_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
